
export default {
  productData: {
    serialNumber: 'DA-MMEU-002',
    name: 'Massivholzdecke mit Estrich und Unterdecke l Aufbau 2',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'U-Abhänger, schallentkoppelt mit Lattung 60/27' },
          output: 80,
          value: 'uas-80'
        },
        {
          type: 'suspendedCeilingA',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '412,5', value: 412.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '35 (1; 7)',
        value: 35
      },
      soundReductionIndex: { // Rw
        output: '84 (-3; -10)',
        value: 84
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,47',
        value: 0.47
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '438 [kg/m²]'
      }
    }
  },
  image: 'da-mmeu-002.png',
  pdf: 'Massivholzdecke-mit-Estrich-und-Unterdecke-Aufbau-2-DA-MMEU-002-Rev01.pdf'
}
